import { render, staticRenderFns } from "./JinoyatchilikkaQarshi.vue?vue&type=template&id=d2951b18&scoped=true&"
import script from "./JinoyatchilikkaQarshi.vue?vue&type=script&lang=js&"
export * from "./JinoyatchilikkaQarshi.vue?vue&type=script&lang=js&"
import style0 from "./JinoyatchilikkaQarshi.vue?vue&type=style&index=0&id=d2951b18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2951b18",
  null
  
)

export default component.exports